import { useNavigate, useParams } from 'react-router-dom';
import { useGetInteractionDictionaryQuery } from 'src/api/interactions-dictionary';
import { useGlobalModals } from 'src/contexts/global-modals';
import { links } from 'src/router/routes';

export const useInteractionDictionaryDetails = () => {
  const { id } = useParams<{ id: string }>();
  const interactionDictionaryId = Number(id);
  const navigate = useNavigate();

  const { openDeleteInteractionDictionaryModal } = useGlobalModals();

  const {
    data: interactionDictionary,
    isPending,
    isError,
  } = useGetInteractionDictionaryQuery(interactionDictionaryId);

  const handleDelete = () => {
    if (interactionDictionary) {
      openDeleteInteractionDictionaryModal(interactionDictionary.id);
    }
  };

  const handleCancel = () => {
    navigate(links.interactionsDictionary);
  };

  const themeOptions =
    interactionDictionary?.themes?.map((theme) => ({
      id: theme.id.toString(),
      image: theme.image,
      label: theme.name,
    })) || [];

  return {
    interactionDictionary,
    isPending,
    isError,
    handleDelete,
    handleCancel,
    themeOptions,
  };
};
